/**
 * @format
 * @flow
 */
import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router';
import DateJp from '../../../../node_modules/UltraDate.js/UltraDate';
import { Link } from 'react-router-dom';
import { getPaymentInfo, resetPaymentInfo } from '../../../actions/Task';
import generateCalendarHash from '../../../lib/generate_calendar_hash';
import Template from '../../../components/Template/AfterLoginTemplate';
import { getSetting } from '../../../actions/Setting';
import * as RT from '../../../constants/Routing';
// import * as RT from '../../constants/Routing'
DateJp.setDefaultLocale('ja');

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: this.props.match.params.year + '/' + this.props.match.params.month // 2019/04から今月までの範囲（実施月）
    };
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount = () => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    this.props.getPaymentInfo(token, enterpriseId, this.state.selectedDate);
    this.props.getSetting(enterpriseId, token, this.currentUser.email);
  };

  componentWillUnmount = () => {
    this.props.resetPaymentInfo();
  };

  _setValue = e => {
    if (e.target.name === 'selectedDate') {
      this.setState({ [e.target.name]: e.target.value }, () => {
        this._getMonthsItems(this.state.selectedDate);
      });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  _getMonthsItems = () => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    this.props.getPaymentInfo(token, enterpriseId, this.state.selectedDate);
  };

  _renderSelectDateOptions = () => {
    // console.log('selectDate', generateCalendarHash.generateYearAndMonth())
    return generateCalendarHash.generateYearAndMonth().map(hash => {
      return (
        <option value={hash.value} key={hash.key}>
          {hash.value}
        </option>
      );
    });
  };

  _renderTaskAdjustments = data => {
    if (data.length > 0) {
      return data.map(item => {
        return (
          <div className="task_adjustment">
            <label>
              ({item.addition ? '+ ' : '- '}
              {item.adjustAmount})
            </label>
          </div>
        );
      });
    }
  };

  _renderPaymentItems = () => {
    const items = this.props.Task.paymentInfo.Items;
    const { feeRate, consumptionTax } = this.props.Task;
    const strRate = feeRate != undefined ? feeRate.replace('%', '') : '0';
    const strTax = feeRate != undefined ? consumptionTax.replace('%', '') : '0';

    if (items !== null && items.constructor === Array && items.length > 0) {
      return items.map(item => {
        var a = Number(item.amount) * (Number.parseInt(strRate) / 100);
        var b = a * (Number.parseInt(strTax) / 100);
        console.log('TCL: _renderPaymentItems -> Number.parseInt(strRate)', a, b);

        return (
          <tr>
            <td>
              <Link to={RT.TASK_SHOW_PATH.replace(/:task_id/, item.taskId)}>{item.taskId}</Link>
            </td>
            <td>{item.title}</td>
            <td>{item.startDate}</td>
            <td>{item.workTime}</td>
            <td>
              {item.taskrewsName.fastName != undefined
                ? item.taskrewsName.lastName + ' ' + item.taskrewsName.fastName
                : ''}
            </td>
            <td>
              {String(item.amount).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}
              {item.taskAdjustmentHistory !== undefined
                ? this._renderTaskAdjustments(item.taskAdjustmentHistory)
                : ''}
            </td>
            <td>
              {String((Number(item.amount) + Number(a) + Number(b)).toFixed(0)).replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                '$1,'
              )}
            </td>
          </tr>
        );
      });
    }
    return (
      <tr>
        <td colSpan="6">請求対象となる実施済みのタスクがありません。</td>
      </tr>
    );
  };

  // eslint-disable-next-line consistent-return
  _renderAdjustments = data => {
    if (data !== undefined && data.length > 0) {
      return data.map((item, index) => {
        return (
          <div className={item.adjustmentType == 1 ? 'cat1-text' : 'cat2-text'}>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label>
              調整{' '}
              <span className={item.adjustmentType == 1 ? 'cat-number1' : 'cat-number2'}>
                {index + 1}
              </span>{' '}
              {item.addition ? '+' : '-'} {item.adjustAmount}円 ({item.reason})
            </label>
          </div>
        );
      });
    }
  };

  render = () => {
    const { totalRewal } = this.props.Task.paymentInfo;
    const paymentInfo = this.props.Task.paymentInfo;
    console.log('TCL: render -> this.props', this.props);
    return (
      <Template>
        <div className="">
          <h2>{paymentInfo.enterpriseName} の請求状況について</h2>
          <div className="row">
            <div className="payment_part1">
              <label className="subtitle" htmlFor="">
                実施月
              </label>
              <select
                className="form-select mb-2 ml-4"
                name="selectedDate"
                id=""
                onChange={this._setValue}
                defaultValue={this.state.selectedDate}
              >
                {this._renderSelectDateOptions()}
              </select>
              <label className="subtitle">請求額 </label>
              <label className="payment_amount">
                {String(totalRewal).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}
              </label>
              <label className="subtitle">円 </label>
            </div>
            <div className="payment_part2">
              {this._renderAdjustments(paymentInfo.adjustmentHistory)}
            </div>
            <div className="payment_part1">
              <label className="subtitle">
                締め日 {paymentInfo.closeDate} (支払い額確定日 {paymentInfo.bufferDate} 日)
              </label>
            </div>
            <div className="payment_part1">
              <label className="subtitle">
                手数料 {paymentInfo.feeRate}% 消費税 {paymentInfo.consumptionTax}
              </label>
            </div>
            <div className="col-12">
              <div className="invoice-table table-responsive">
                <table className="table payment-table">
                  <thead>
                    <tr>
                      <th>タスクID</th>
                      <th>タスク名</th>
                      <th>日付</th>
                      <th>時間帯</th>
                      <th>タスクルー</th>
                      <th>報酬</th>
                      <th>請求額</th>
                    </tr>
                  </thead>
                  <tbody>{this._renderPaymentItems()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch =>
  bindActionCreators({ getPaymentInfo, resetPaymentInfo, getSetting }, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
